import { NonIndexRouteObject } from "react-router-dom";
import { ErrorElement } from "../../components/error-element/ErrorElement";
import { errorText } from "../../statics/error-text";
import { PUBLIC_LAYOUT_ID } from "./Public.Parts";

// LOADER

// WRAPPER

// LAYOUT
/** @todo - try LayoutRoutesProps return type when app routing is more stable */
export const PublicLayout: NonIndexRouteObject = {
  id: PUBLIC_LAYOUT_ID,
  errorElement: <ErrorElement errorText={errorText} />,
};
